<template>
  <v-combobox
      :loading="isLoading"
      item-value="key"
      item-text="value"
      :items="items"
      :value="current"
      :label="label"
      :readonly="readonly || isLoading"
      :clearable="!readonly"
      return-object
      eager
      @change="change" />
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { LOT_ORDERS } from '@/constants/store.js'

  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: ''
      },
      lotId: {
        type: String,
        required: true
      },
      lotType: {
        type: String,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_ORDERS.NAMESPACE, {
        organizations: state => (state[LOT_ORDERS.STATE.TRADE_RESULTS_ORGANIZATIONS] || [])
      }),
      items () {
        return this.organizations.map(u => (
          {
            key: u.organizationId,
            value: u.organizationName
          }))
      },
      current () {
        const vm = this
        return vm.items.find(u => u.key === vm.value)
      }
    },
    created () {
      this.clearStore().then(() => {
        this.getTradeResultsOrganizations()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_ORDERS.NAMESPACE, {
        getTradeResultsOrganizationsAction: LOT_ORDERS.ACTIONS.GET_TRADE_RESULTS_ORGANIZATIONS,
        clearTradeResultsOrganizationsAction: LOT_ORDERS.ACTIONS.CLEAR_TRADE_RESULTS_ORGANIZATIONS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearTradeResultsOrganizationsAction()
          ])
      },
      getTradeResultsOrganizations: async function () {
        try {
          this.isLoading = true
          await this.getTradeResultsOrganizationsAction({
            lotId: this.lotId,
            lotType: this.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      change: function (item) {
        this.$emit('input', item ? item.key : null)
        this.$nextTick(() => {
          this.$emit('change')
        })
      }
    }
  }
</script>
